import { useState } from "react"
import { useNavigate } from "react-router-dom";
import routes from "../constants/routes"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import TabPanel from "../components/ui/TabPanel"
import { Stack } from "@mui/material"
import { UpcomingClasses } from "../components/classes/UpcomingClasses"
import { PreviousClasses } from "../components/classes/PreviousClasses"
import { Submissions } from "../components/classes/Submissions"
import TabLogo from "../components/common/TabLogo"

const Home = ({tab, submissionsTab}) => {
  const [value, setValue] = useState(tab || 0)
  const navigate = useNavigate()
  const handleChange = (_, newValue) => {
    setValue(newValue)
    switch(newValue) {
      case 0:
        navigate(routes.CLASSES.UPCOMING, {replace: true})
        break
      case 1:
        navigate(routes.CLASSES.PREVIOUS, {replace: true})
        break
      case 2:
        navigate(routes.CLASSES.SUBMISSIONS, {replace: true})
        break
      default:
        navigate(routes.CLASSES.UPCOMING, {replace: true})
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction={"row"} sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabLogo />
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons
          allowScrollButtonsMobile
        >
          <Tab label="Upcoming Classes" />
          <Tab label="Previous Classes" />
          <Tab label="Submissions" />
        </Tabs>
      </Stack>
      <TabPanel value={value} index={0}>
        <UpcomingClasses />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PreviousClasses />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Submissions tab={submissionsTab}/>
      </TabPanel>
    </Box>
  )
}

export default Home
